import { Component } from '@angular/core';
import { TitleService } from '../../services/title.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-servizi',
    imports: [RouterModule, CommonModule],
    templateUrl: './servizi.component.html',
    styleUrl: './servizi.component.css'
})
export class ServiziComponent {

  constructor(private ts : TitleService, public router: Router) {  }

  ngOnInit(){
    this.ts.titolo = "Servizi";
  }
}
